import React from 'react';
import { List } from '@mui/material';
import RoleToggleSwitch from './RoleToggleSwitch';

/**
 * MenuSection - Component for rendering menu sections with optional role toggle
 * 
 * @param {Object} props - Component props
 * @param {string} props.userType - The user's role type
 * @param {Array} props.menuItems - Array of menu items to render
 * @param {Array} [props.bottomMenuItems] - Optional bottom menu items
 * @param {Function} props.renderMenuItems - Function to render menu items
 * @param {string} [props.typeOfUser] - Current active role for role toggle
 * @param {Object} [props.user] - User object for role toggle
 * @param {Function} [props.handleRoleToggle] - Function to handle role switching
 * @param {boolean} [props.showRoleToggle=false] - Whether to show role toggle switch
 * @returns {JSX.Element} Rendered menu section
 */
const MenuSection = React.memo(({
  userType,
  menuItems,
  bottomMenuItems,
  renderMenuItems,
  typeOfUser,
  user,
  handleRoleToggle,
  showRoleToggle = false
}) => {
  return (
    <>
      <List className='topSection'>
        {renderMenuItems(menuItems)}
      </List>
      {bottomMenuItems && (
        <List className='bottomSection'>
          {renderMenuItems(bottomMenuItems)}
        </List>
      )}
      {showRoleToggle && (
        <List>
          <RoleToggleSwitch
            userType={userType}
            typeOfUser={typeOfUser}
            user={user}
            handleRoleToggle={handleRoleToggle}
          />
        </List>
      )}
    </>
  );
});

export default MenuSection; 